import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Wrench, ClipboardCheck, Calendar, FolderOpen, Gift } from 'lucide-react';
const features = [{
  icon: BookOpen,
  title: 'Unidades completas',
  description: 'Introducción, señalización, EPP, prevención, primeros auxilios, emergencias y riesgos reales — cada unidad con actividades y evaluación.',
  color: 'bg-blue-100 text-blue-600'
}, {
  icon: Wrench,
  title: 'Guías de actividades',
  description: 'Casos reales, inspecciones, evacuaciones, protocolos y prácticas aplicadas.',
  color: 'bg-orange-100 text-orange-600'
}, {
  icon: ClipboardCheck,
  title: 'Checklists y rúbricas',
  description: 'Para evaluar por competencias reales, no solo por memoria.',
  color: 'bg-green-100 text-green-600'
}, {
  icon: Calendar,
  title: 'Planificación anual',
  description: 'Clases armadas, semana por semana, sin improvisar.',
  color: 'bg-purple-100 text-purple-600'
}, {
  icon: FolderOpen,
  title: 'Material editable',
  description: 'Listo para usar en aula, taller u obra. Todo organizado.',
  color: 'bg-yellow-100 text-yellow-600'
}, {
  icon: Gift,
  title: 'Bonos incluidos',
  description: 'Señalización, EPP y emergencias (material profesional extra).',
  color: 'bg-red-100 text-red-600'
}];
export function FeaturesGrid() {
  return <section className="py-20 bg-white" data-id="element-77">
      <div className="container mx-auto px-4" data-id="element-78">
        <div className="text-center mb-16" data-id="element-79">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-80">
            ¿Qué obtendrás?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-81">
            Estas son las razones por las que todos eligen este Mega Pack
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-82">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-all hover:-translate-y-1" data-id="element-83">
              <div className={`w-16 h-16 rounded-2xl ${feature.color} flex items-center justify-center mb-6`} data-id="element-84">
                <feature.icon className="w-8 h-8" data-id="element-85" />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-3" data-id="element-86">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-87">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}